export const CloseMenuIcon = ({
    width = 16,
    height = 16,
    color = "#1D201E",
}) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 16 16"
        fill="none"
    >
        <rect width={width} height={height} fill="white" fill-opacity="0.01" />
        <path
            d="M12 4.7L11.3 4L8 7.3L4.7 4L4 4.7L7.3 8L4 11.3L4.7 12L8 8.7L11.3 12L12 11.3L8.7 8L12 4.7Z"
            fill={color}
        />
    </svg>
);
